import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import theme from './theme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js'
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { store } from './app/store'
import { Provider } from 'react-redux'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

ReactDOM.hydrate(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <Provider store={store}>
          <Router>
            <HelmetProvider>
              <Elements stripe={stripePromise}>
                <App  />
              </Elements>
            </HelmetProvider>
          </Router>
      </Provider>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
